import "core-js/modules/es.function.name";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { Link } from "../../Common";
import { Text } from "../../Typography";
import styles from './RadioButton.scss';

var RadioButton = function RadioButton(_ref) {
  var _classnames;

  var id = _ref.id,
      label = _ref.label,
      value = _ref.value,
      name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'standard' : _ref$size,
      wide = _ref.wide,
      error = _ref.error,
      className = _ref.className,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      onChange = _ref.onChange,
      to = _ref.to;

  var handleChange = function handleChange() {
    if (onChange) {
      onChange(value);
    }
  };

  var componentClassName = classnames(styles.radioButton, (_classnames = {}, _defineProperty(_classnames, styles["size--".concat(String(size))], size !== 'standard'), _defineProperty(_classnames, styles.wide, wide), _defineProperty(_classnames, styles.hasError, !!error), _defineProperty(_classnames, styles.checked, isChecked), _classnames));
  return /*#__PURE__*/React.createElement(React.Fragment, null, to !== undefined ?
  /*#__PURE__*/
  // TODO: Remove Link component from RadioButton
  React.createElement(Link, {
    to: to,
    className: classnames(componentClassName, className)
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span"
  }, label)) : /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: className
  }, /*#__PURE__*/React.createElement("input", {
    className: styles.nativeRadio,
    id: id,
    type: "radio",
    value: value,
    name: name,
    disabled: isDisabled,
    checked: isChecked,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span"
  }, label))));
};

export default RadioButton;